export enum RenovationType {
    UNKNOWN = 0,
    DESIGN = 1,
    EURO = 2,
    NEED = 3,
    GOOD = 4,
    PARTIAL = 5,
    PRE_FINE = 6,
    FINE = 7,
    ROUGH = 8
}
